import { render, staticRenderFns } from "./QuestDetails.vue?vue&type=template&id=861952dc&"
import script from "./QuestDetails.vue?vue&type=script&lang=js&"
export * from "./QuestDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuestDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports